// 대시보드 API 클라이언트.
//
// 예전에는 인증 헤더가 없는 별도 axios 인스턴스였다 — 백엔드 /dashboards/* 가 무인증으로 열려 있어
// 동작은 했지만, 그 때문에 토큰 없이도 마크업 트렌드·베스트 상품을 받아갈 수 있었다(2026-09 수집 스크립트).
// 백엔드가 로그인을 요구하도록 바뀌어 공용 클라이언트를 그대로 쓴다: 토큰 부착, 만료 전 갱신,
// 401 시 1회 재시도, 30초 타임아웃. 배열 파라미터는 brand_ids=1&brand_ids=2 (repeat) 로 나간다.
import axiosClient from "@/utils/axios-client";

export const apiClient = axiosClient;

export default apiClient;
